import React from 'react';
import gql from 'graphql-tag';
import FacilityUnits from '../../../components/stateful/FacilityUnits';

const propTypes = {};

const defaultProps = {};

const FacilityUnitsTwo = props => (
  <FacilityUnits
    {...props}
    tableTheme="two"
  />
);

FacilityUnitsTwo.propTypes = propTypes;
FacilityUnitsTwo.defaultProps = defaultProps;

FacilityUnitsTwo.fragments = {
  facility: gql`
    fragment FacilityUnitsTwoFacility on Facility {
      ...FacilityUnitsFacility
    }

    ${FacilityUnits.fragments.facility}
  `,
};

export default FacilityUnitsTwo;
